import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/user';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClientRepository } from '../../../client.service';
import { Client } from '../../../models/client';
import { UserService } from '../../../shared/user.service';
import { ActiveModal } from '../../../core/modal.service';
import { ToastsManager } from 'ng2-toastr';
import { ModalComponent } from '../../../core/modal.component';

@Component({
  selector: 'cw-edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  styleUrls: ['./edit-user-modal.component.scss']
})
export class EditUserModalComponent extends ModalComponent implements OnInit {
  user: User;
  form: FormGroup;
  isSaving: boolean = false;
  errorMessage: string;
  opened: boolean;

  constructor(private fb: FormBuilder,
              public activeModal: ActiveModal,
              private clientService: ClientRepository,
              private toastr: ToastsManager,
              private userService: UserService) {
    super(activeModal);
    this.buildForm();
  }

  initEdit(user: User) {
    this.user = user;
    this.form.setValue({
      name: this.user.name,
      email: this.user.email,
      client: this.user.client.id,
      send_password: false
    });
    this.opened = true;
  }

  initCreate(client?: Client) {
    this.form.setValue({
      name: '',
      email: '',
      client: client ? client.id : null,
      send_password: true
    });
    this.opened = true;
  }

  destroy() {
    if (!confirm('Ta bort användaren?')) {
      return;
    }

    this.userService.destroy(this.user).subscribe(() => {
      this.activeModal.close(this.user);
    })
  }

  ngOnInit() {
  }

  save() {
    this.isSaving = true;
    const values = this.form.value;

    if (this.user) {
      this.userService.update(this.user, values)
        .finally(() => this.isSaving = false)
        .subscribe(user => {
          this.activeModal.close(user);
        }, err => {
          this.errorMessage = 'Fel vid sparande';
        });
    } else {
      this.userService.create(values)
        .finally(() => this.isSaving = false)
        .subscribe(user => {
          this.activeModal.close(user);
        }, err => {
          this.errorMessage = 'Kunde inte skapa användare';
        });
    }
  }

  private buildForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      client: ['', Validators.required],
      send_password: [true, null]
    });
  }

  get isExisting() {
    return this.user && !!this.user.id;
  }

  get clients() {
    return this.clientService.clients;
  }
}



// WEBPACK FOOTER //
// ./src/app/users/shared/edit-user-modal/edit-user-modal.component.ts